import {FulfillmentStatus, RequestFulfillmentDefinition} from 'requests/fulfillments/FulfillmentConstants';

import {ExecutionType, PaneKey} from './ExecuteRequestFlowConstants';

export enum ExecuteRequestFlowActionType {
  OPEN_EXECUTE_REQUEST_FLOW = 'OPEN_EXECUTE_REQUEST_FLOW',
  CLOSE_EXECUTE_REQUEST_FLOW = 'CLOSE_EXECUTE_REQUEST_FLOW',
  EXECUTE_REQUEST_FLOW_GO_TO_PREV_PANE = 'EXECUTE_REQUEST_FLOW_GO_TO_PREV_PANE',
  EXECUTE_REQUEST_FLOW_GO_TO_NEXT_PANE = 'EXECUTE_REQUEST_FLOW_GO_TO_NEXT_PANE',
  EXECUTE_REQUEST_FLOW_SET_SELECTED_EXECUTED_FULFILLMENT_DEFINITIONS = 'EXECUTE_REQUEST_FLOW_SET_SELECTED_EXECUTED_FULFILLMENT_DEFINITIONS',
  EXECUTE_REQUEST_FLOW_SET_SELECTED_FULFILLMENT_DEFINITIONS = 'EXECUTE_REQUEST_FLOW_SET_SELECTED_FULFILLMENT_DEFINITIONS',
  EXECUTE_REQUEST_FLOW_SET_STATUS_FILTER = 'EXECUTE_REQUEST_FLOW_SET_STATUS_FILTER',
  EXECUTE_REQUEST_FLOW_SET_EXECUTION_TYPE = 'EXECUTE_REQUEST_FLOW_SET_EXECUTION_TYPE',
}

interface OpenExecuteRequestFlowAction {
  type: ExecuteRequestFlowActionType.OPEN_EXECUTE_REQUEST_FLOW;
  excludedPanes: Array<PaneKey>;
  paneKey: PaneKey | null;
}

export function openExecuteRequestFlow({
  excludedPanes,
  paneKey,
}: {
  excludedPanes: Array<PaneKey>;
  paneKey: PaneKey | null;
}): OpenExecuteRequestFlowAction {
  return {
    type: ExecuteRequestFlowActionType.OPEN_EXECUTE_REQUEST_FLOW,
    excludedPanes,
    paneKey,
  };
}

interface CloseExecuteRequestFlowAction {
  type: ExecuteRequestFlowActionType.CLOSE_EXECUTE_REQUEST_FLOW;
}

export function closeExecuteRequestFlow(): CloseExecuteRequestFlowAction {
  return {
    type: ExecuteRequestFlowActionType.CLOSE_EXECUTE_REQUEST_FLOW,
  };
}

interface GoToPrevPaneAction {
  type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_GO_TO_PREV_PANE;
}

export function goToPrevPane(): GoToPrevPaneAction {
  return {
    type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_GO_TO_PREV_PANE,
  };
}

interface GoToNextPaneAction {
  type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_GO_TO_NEXT_PANE;
}

export function goToNextPane(): GoToNextPaneAction {
  return {
    type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_GO_TO_NEXT_PANE,
  };
}

interface SetSelectedFulfillmentDefinitionsAction {
  type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_SELECTED_FULFILLMENT_DEFINITIONS;
  fulfillmentDefinitions: Array<RequestFulfillmentDefinition>;
}

export function setSelectedFulfillmentDefinitions(
  fulfillmentDefinitions: Array<RequestFulfillmentDefinition>
): SetSelectedFulfillmentDefinitionsAction {
  return {
    type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_SELECTED_FULFILLMENT_DEFINITIONS,
    fulfillmentDefinitions,
  };
}

interface SetSelectedExecutedFulfillmentDefinitionsAction {
  type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_SELECTED_EXECUTED_FULFILLMENT_DEFINITIONS;
  fulfillmentDefinitions: Array<RequestFulfillmentDefinition>;
}

export function setSelectedExecutedFulfillmentDefinitions(
  fulfillmentDefinitions: Array<RequestFulfillmentDefinition>
): SetSelectedExecutedFulfillmentDefinitionsAction {
  return {
    type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_SELECTED_EXECUTED_FULFILLMENT_DEFINITIONS,
    fulfillmentDefinitions,
  };
}

interface SetStatusFilterAction {
  type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_STATUS_FILTER;
  statusFilter: FulfillmentStatus;
}

export function setStatusFilter(statusFilter: FulfillmentStatus): SetStatusFilterAction {
  return {
    type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_STATUS_FILTER,
    statusFilter,
  };
}

interface SetExecutionTypeAction {
  type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_EXECUTION_TYPE;
  executionType: ExecutionType;
}

export function setExecutionType(executionType: ExecutionType): SetExecutionTypeAction {
  return {
    type: ExecuteRequestFlowActionType.EXECUTE_REQUEST_FLOW_SET_EXECUTION_TYPE,
    executionType,
  };
}

export type ExecuteRequestFlowAction =
  | OpenExecuteRequestFlowAction
  | CloseExecuteRequestFlowAction
  | GoToPrevPaneAction
  | GoToNextPaneAction
  | SetSelectedFulfillmentDefinitionsAction
  | SetSelectedExecutedFulfillmentDefinitionsAction
  | SetStatusFilterAction
  | SetExecutionTypeAction;
